import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createRouter, createWebHistory } from 'vue-router';
import { createApp } from 'vue';

import App from './App.vue';
import Home from './components/Home.vue';
import ClarinIT from './components/ClarinIT.vue';
import CaterinaBueno from './components/CaterinaBueno.vue';
import PatrimonioAudiovisivo from './components/PatrimonioAudiovisivo.vue';


const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: Home },
    { path: '/clarin-it', component: ClarinIT },
    { path: '/caterina-bueno', component: CaterinaBueno },
    { path: '/patrimonio-audiovisivo', component: PatrimonioAudiovisivo }
  ],
  linkActiveClass: 'active'
});

const app = createApp(App)

app.use(router);

// remove animation on first load
// router.isReady().then(function(){
//   app.mount('#app');
// });

app.mount('#app');
